// extracted by mini-css-extract-plugin
export default {"rating":"Ty-z","numberOfStars":"Uy-z","count":"Vy-z","barGraphSpacing":"Wy-z","barGraph":"Xy-z"};